export * from './simple-comment.component';